/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectGroup,
    ReadOnlyMonitoredObjectGroupFromJSON,
    ReadOnlyMonitoredObjectGroupFromJSONTyped,
    ReadOnlyMonitoredObjectGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20024
 */
export interface InlineResponse20024 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20024
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20024
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20024
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectGroup>}
     * @memberof InlineResponse20024
     */
    results: Array<ReadOnlyMonitoredObjectGroup>;
}

export function InlineResponse20024FromJSON(json: any): InlineResponse20024 {
    return InlineResponse20024FromJSONTyped(json, false);
}

export function InlineResponse20024FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20024 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectGroupFromJSON)),
    };
}

export function InlineResponse20024ToJSON(value?: InlineResponse20024 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectGroupToJSON)),
    };
}


